import React from "react";
import ContentLoader from "react-content-loader"

export default function ListLoader() {
  return (
    <li className="item">
      <ContentLoader
        height={180}
        width={620}
        speed={3}
        primaryColor="#f3f3f3"
        secondaryColor="#b2c9e0"
      >
        <rect x="25" y="32" rx="0" ry="0" width="100" height="118" />
        <rect x="144" y="32" rx="0" ry="0" width="280" height="29" />
        <rect x="144" y="72" rx="0" ry="0" width="450" height="78.28" />
      </ContentLoader>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/components/ListLoader.js